import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import { Plus, PrintSignIn, Tick } from '../../helpers/icon-dictionary';
import css from './index.scss';
import SvgIcon from '../svg-icon/svg-icon';
import Button from '../../components/button/index';
import messages from './messages';
import Modal from '../modal';
import SignInCardsFormats from '../sign-in-cards-formats';

const StudentConfirmation = ({ icon,
    title,
    showHideSignInCardModal = false,
    handleOnAddStudent,
    handleOnCloseModal,
    handleOnPrintSignInCard,
    isSignInCardDownloaded = true,
    intl,
    handleOnStudentSignInCards,
    handleOnCancelStudentSignInCards
}) => (
    <div>
        <div className={css.studentConfirmationContainer}>
            <div className={css.icon}>
                <SvgIcon icon={icon} />
            </div>
            <div className={css.title}>{title}</div>
            <Button
                buttonContainer={css.buttonContainer}
                containerClassName={css.buttonWrapper}
                handleOnClick={handleOnAddStudent}
                icon={Plus}
                iconClassName={css.buttonIcon}
                label={intl.formatMessage(messages.addAnotherStudent)} />
            <Button
                buttonContainer={css.buttonContainer}
                buttonContainerDisabled={css.buttonContainerDisabled}
                containerClassName={css.buttonWrapper}
                handleOnClick={handleOnStudentSignInCards}
                icon={PrintSignIn}
                iconClassName={css.buttonIcon}
                label={intl.formatMessage(messages.printSignInCard)}
            />
            <Button
                buttonContainer={css.buttonContainer}
                containerClassName={css.buttonWrapper}
                handleOnClick={handleOnCloseModal}
                icon={Tick}
                iconClassName={css.buttonIcon}
                label={intl.formatMessage(messages.done)} />
        </div>
        <Modal show={showHideSignInCardModal}>
            <SignInCardsFormats
                handleOnCancel={handleOnCancelStudentSignInCards}
                handleOnDownloadSignInCards={handleOnPrintSignInCard}
                isSignInCardDownloaded={isSignInCardDownloaded} />
        </Modal>
    </div>
);

StudentConfirmation.propTypes = {
    icon: PropTypes.string,
    title: PropTypes.string,
    handleOnAddStudent: PropTypes.func,
    handleOnCloseModal: PropTypes.func,
    handleOnPrintSignInCard: PropTypes.func,
    isSignInCardDownloaded: PropTypes.bool,
    intl: intlShape.isRequired,
    showHideSignInCardModal: PropTypes.bool,
    handleOnStudentSignInCards: PropTypes.func,
    handleOnCancelStudentSignInCards: PropTypes.func
};

export default injectIntl(StudentConfirmation);



// WEBPACK FOOTER //
// ./app/components/student-confirmation/index.js